import React, { Component } from 'react';
import {Redirect} from 'react-router';
import { NavLink,withRouter } from 'react-router-dom';
import {Navbar,NavbarBrand, Nav,NavItem,Button,Collapse,NavbarToggler,
    Modal,ModalHeader,ModalBody,Badge} from 'reactstrap';
import '../css/comman.css';
// import logo from '../shared/images/datastack_logo.png';
// import logo2 from '../shared/images/d.png';
class Header extends Component{
    constructor(props){
        super(props);
        this.state = {
            isNavOpen:false,
            isModalOpen:false
        }
    }

    toggleNav= ()=> {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        });
    }

    clickLogin=()=>{
        this.props.history.push("/login");
    }

    clickSignUp=()=>{
        this.props.history.push("/signup");
    }

    clickInstruction=()=>{
        this.props.history.push("/instruction");
    }

    clickDashboard=()=>{
        this.props.history.push("/dashboard");
    }

    toggleModal= ()=> {
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    render(){
        return(
            <div>
                <Navbar color="dark" expand="md" dark>
                <NavbarBrand className="navbrand" href="/home">
                    {/* <span><img src={logo2} height="40" width="55"
                                        alt="DataStack" /></span> */}
                    DataStack
                    {/* <div className="row m-auto">
                        <div>
                            <img src={logo2} height="30" width="40"
                                    alt="DataStack" />
                        </div>
                        <div 
                            className="mt-2 mr-auto"
                            style={{
                                marginLeft:-10,
                                paddingTop:1
                            }}
                            >
                            DataStack
                        </div>
                    </div>   */}
                </NavbarBrand>
                    <NavbarToggler 
                        // onClick={this.toggleNav}
                        onClick={this.toggleNav}
                        />
                    <Collapse isOpen={this.state.isNavOpen} navbar>
                            { 
                                !this.props.user.isAuthenticated ?
                                <Nav className="ml-auto" navbar>
                                    <NavItem className="mt-1 mr-3">
                                            <NavLink 
                                                style={{color:'#EFEFEF'}} 
                                                to='/instruction'>Instruction
                                            </NavLink>
                                    </NavItem>
                                    <NavItem className="mt-1 mr-3">
                                        <a
                                            href="javascript:void(0);"
                                            style={{color:'#EFEFEF'}}
                                            onClick={()=>
                                                this.setState({
                                                    isModalOpen:!this.state.isModalOpen
                                                })
                                            }>Contact</a>
                                    </NavItem>
                                    <NavItem className="mt-1 mr-3">
                                            <NavLink 
                                                style={{color:'#EFEFEF'}} 
                                                to='/login'>Login
                                            </NavLink>
                                    </NavItem>
                                    <NavItem className="mt-1 mr-1">
                                            <NavLink 
                                                style={{color:'#EFEFEF'}} 
                                                to='/signup'>SignUp
                                            </NavLink>
                                    </NavItem>
                                </Nav>
                                :
                                <Nav className="ml-auto" navbar>
                                    <NavItem className="mt-2 mr-3">
                                            <NavLink 
                                                style={{color:'#EFEFEF'}} 
                                                to='/ranks'>Rank
                                            </NavLink>
                                    </NavItem>
                                    <NavItem className="mt-2 mr-3">
                                            <NavLink
                                            style={{color:'#EFEFEF'}} 
                                            to='/dashboard'>Dashboard
                                            </NavLink>
                                    </NavItem>
                                    <NavItem className="mt-2 mr-3">
                                            <NavLink 
                                                style={{color:'#EFEFEF'}} 
                                                to='/instruction'>Instructions
                                            </NavLink>
                                    </NavItem>
                                    <NavItem className="mt-2 mr-3">
                                        <a
                                            href="javascript:void(0);"
                                            style={{color:'#EFEFEF'}}
                                            onClick={()=>
                                                this.setState({
                                                    isModalOpen:!this.state.isModalOpen
                                                })
                                            }>Contact</a>
                                    </NavItem>
                                    <NavItem className="mt-1 mr-1">
                                        <Button 
                                            onClick={this.props.logoutUser}
                                            size="sm">
                                            Logout
                                        </Button>
                                    </NavItem>
                                </Nav>
                            }
                    </Collapse>
                </Navbar>

                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>Contact Us</ModalHeader>
                    <ModalBody>
                        <div className="row m-auto">
                            <div className="mt-1">
                                <h6>Reach us at:</h6>
                            </div>
                            <div className="ml-2">
                                <h5><Badge color="primary">datastack_team@datastack.ml</Badge></h5>
                            </div>
                        </div>
                        <Button
                            onClick={()=>{
                                this.setState({
                                    isModalOpen:!this.state.isModalOpen
                                })
                            }}
                            size="sm"
                        >Close</Button>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

export default withRouter(Header);
